import { Solar, Lunar } from 'lunar-javascript';

/**
 * Danh sách ngày lễ Việt Nam (Dương lịch) - định dạng MM-DD
 */
export const VIETNAM_HOLIDAYS_SOLAR = [
  '01-01', // Tết Dương lịch
  '03-10', // Giỗ Tổ Hùng Vương
  '04-30', // Giải phóng miền Nam
  '05-01', // Quốc tế Lao động
  '09-02', // Quốc khánh
];

/**
 * Kiểm tra có phải ngày lễ dương lịch không
 * @param {Date} date - Ngày cần kiểm tra
 * @returns {boolean}
 */
export const isSolarHoliday = (date) => {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const dateKey = `${month}-${day}`;
  return VIETNAM_HOLIDAYS_SOLAR.includes(dateKey);
};

/**
 * Kiểm tra có phải Tết Âm lịch không (29 Tết → 5 Tết)
 * @param {Date} date - Ngày cần kiểm tra
 * @returns {boolean}
 */
export const isLunarNewYear = (date) => {
  try {
    const solar = Solar.fromDate(date);
    const lunar = solar.getLunar();

    const lunarMonth = lunar.getMonth();
    const lunarDay = lunar.getDay();

    // 29-30 tháng 12 âm lịch
    if (lunarMonth === 12 && lunarDay >= 29) {
      return true;
    }

    // 1-5 tháng 1 âm lịch
    if (lunarMonth === 1 && lunarDay <= 5) {
      return true;
    }

    return false;
  } catch (error) {
    console.error('Error checking lunar new year:', error);
    return false;
  }
};

/**
 * Kiểm tra có phải cuối tuần không (Thứ 7, Chủ nhật)
 * @param {Date} date - Ngày cần kiểm tra
 * @returns {boolean}
 */
export const isWeekend = (date) => {
  const day = date.getDay();
  return day === 0 || day === 6; // 0 = Chủ nhật, 6 = Thứ 7
};

/**
 * Kiểm tra có phải ngày không giao dịch không
 * @param {Date} date - Ngày cần kiểm tra
 * @returns {boolean}
 */
export const isNonTradingDay = (date = new Date()) => {
  return isWeekend(date) || isSolarHoliday(date) || isLunarNewYear(date);
};

/**
 * Lấy thông tin chi tiết về ngày
 * @param {Date} date - Ngày cần kiểm tra
 * @returns {Object}
 */
export const getDayInfo = (date = new Date()) => {
  const dayOfWeek = date.getDay();
  const hour = date.getHours();

  let timeOfDay = 'casual';
  if (hour >= 6 && hour < 12) timeOfDay = 'morning';
  else if (hour >= 12 && hour < 18) timeOfDay = 'afternoon';
  else if (hour >= 19 || hour < 6) timeOfDay = 'evening';

  return {
    dayOfWeek, // 0-6 (0 = Chủ nhật)
    hour,
    timeOfDay, // 'morning' | 'afternoon' | 'evening' | 'casual'
    isWeekend: isWeekend(date),
    isSolarHoliday: isSolarHoliday(date),
    isLunarNewYear: isLunarNewYear(date),
    isNonTradingDay: isNonTradingDay(date),
  };
};

/**
 * Lấy tên ngày lễ (nếu có)
 * @param {Date} date - Ngày cần kiểm tra
 * @returns {string|null}
 */
export const getHolidayName = (date) => {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const dateKey = `${month}-${day}`;

  const holidayNames = {
    '01-01': 'Tết Dương lịch',
    '03-10': 'Giỗ Tổ Hùng Vương',
    '04-30': 'Ngày Giải phóng miền Nam',
    '05-01': 'Ngày Quốc tế Lao động',
    '09-02': 'Ngày Quốc khánh',
  };

  if (isLunarNewYear(date)) {
    return 'Tết Nguyên Đán';
  }

  return holidayNames[dateKey] || null;
};
